/* @ngInject */
export class PropertiesListController {
  /* @ngInject */
  constructor () {

  }

}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/PropertiesList/properties-list.controller.js